module.exports = __webpack_public_path__ + "static/О реестре государственных должностей РС(Я) (ред от 30_05_2017).doc";